import { cn } from "@/lib/utils";

export type TimelineStep = {
  step: string;
  title: string;
  description: string;
  badge?: string;
};

type VerticalTimelineProps = {
  steps: TimelineStep[];
  className?: string;
};

export function VerticalTimeline({ steps, className }: VerticalTimelineProps) {
  return (
    <div className={cn("relative", className)}>
      <div
        className="absolute left-3 top-0 bottom-0 w-px bg-gradient-to-b from-border via-border to-transparent"
        aria-hidden
      />
      <ol className="space-y-10">
        {steps.map((item) => (
          <li key={item.step} className="relative flex gap-6 pl-8 sm:pl-10">
            <span
              className="absolute left-3 top-[0.35rem] flex h-6 w-6 -translate-x-1/2 shrink-0 items-center justify-center rounded-full border border-border bg-background font-mono text-[11px] font-medium text-foreground shadow-sm"
              aria-hidden
            >
              {item.step}
            </span>
            <div className="min-w-0 flex-1 pb-1">
              <div className="flex flex-wrap items-center gap-3">
                <h3 className="text-base font-medium text-foreground">{item.title}</h3>
                {item.badge != null && (
                  <span className="rounded-full border border-border/60 bg-muted/30 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
                    {item.badge}
                  </span>
                )}
              </div>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {item.description}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
